import React, {  useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
//import { ProductService } from './service/ProductService';

export default function TestClientTable({data}) {
    //const [products, setProducts] = useState([]);

    useEffect(() => {
        //ProductService.getProductsMini().then(data => setProducts(data));
    }, []);

    return (
        <>

            <div>
                <h5>Clientes</h5>
            </div>
            
            
        
            <div className="card">
                <DataTable stripedRows value={data} tableStyle={{ minWidth: '50rem' }}>
                    <Column field="client_name" header="Nombre"></Column>
                    <Column field="client_phone_number" header="Telefono"></Column>
                    <Column field="especialidad" header="Especialidad"></Column>
                    <Column field="notified_express" header="Notificado"></Column>
                </DataTable>
            </div>
        </>
    );
}